import { Transform, Type } from 'class-transformer'
import { DateTime } from 'luxon'
import { NurseTier, Role } from 'types/types'

export default class PreferredNurse {
    id!: number
    practice_id!: number
    nurse_id!: number

    @Type(() => DateTime)
    @Transform(({ value }) => DateTime.fromISO(value))
    created_at!: DateTime

    // Annotated practice fields
    practice_name!: string
    practice_group_id!: number
    practice_group_name!: string

    // Annotated nurse fields
    nurse_user_id!: number
    nurse_name!: string
    nurse_enabled!: boolean
    nurse_tier!: NurseTier
    nurse_role!: Role

    // Annotated access control fields
    can_access_preferred_nurse!: boolean
    cannot_access_preferred_nurse_reason!: string
    can_delete_preferred_nurse!: boolean
    cannot_delete_preferred_nurse_reason!: string

    get created_at_label() {
        return this.created_at.toFormat('LLL dd yyyy h:mm a')
    }
}